import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  cookieAgreementText: {
    id: 'component.Layout.CookieBar.cookieAgreementText',
    defaultMessage:
      'Ta witryna wykorzystuje pliki cookies do przechowywania informacji na Twoim komputerze. Pliki cookies stosujemy w celu świadczenia usług na najwyższym poziomie, w tym w sposób dostosowany do indywidualnych potrzeb. Korzystanie z witryny bez zmiany ustawień dotyczących cookies oznacza, że będą one zamieszczane w Twoim urządzeniu końcowym. W każdym momencie możesz dokonać zmiany ustawień dotyczących cookies.'
  },
  cookieButtonText: {
    id: 'component.Layout.CookieBar.cookieButtonText',
    defaultMessage: 'Akceptuj'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/CookieBar/CookieBar.intl.js